module.exports = __webpack_public_path__ + "img/Logo-20.5ef48dea.svg";